// Attribution: https://github.com/mui-org/material-ui/tree/next/docs/src/pages/getting-started/templates/sticky-footer
// Dependencies
import React from 'react';

// Material
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

function Copyright() {
	return (
		<Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
			{'©'}
			{new Date().getFullYear()}
			{'.'}
			{'Official web site of The City of Calgary, located in Calgary, Alberta, Canada.'}
		</Typography>
	);
}

function StickyFooter() {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				backgroundColor: (theme) => theme.palette.secondary.dark,
				color: (theme) => theme.palette.secondary.contrastText,
				'& a': {
					color: 'white',
					textDecorationColor: 'white',
					'&:visited': {
						color: 'white'
					},
					'&:focus': {
						color: 'white'
					}
				}
			}}
		>
			<CssBaseline />
			<Container
				component="main"
				sx={{
					marginTop: '4rem',
					marginBottom: '1rem',
					textAlign: 'center'
				}}
			>
				<Typography variant="body1">
					<Link href="https://www.calgary.ca/general/privacy-policy.html">Privacy Policy</Link>
					{' | '}
					<Link href="https://www.calgary.ca/general/terms-of-use.html">Terms of Use</Link>
					{' | '}
					<Link href="https://www.calgary.ca/general/accessibility.html">Accessibility</Link>
				</Typography>

				<Box
					component="footer"
					sx={{
						padding: '1.5rem 1rem',
						marginTop: 'auto'
					}}
				>
					<Container>
						<Copyright />
					</Container>
				</Box>
			</Container>
		</Box >
	);
}

export { StickyFooter };
